import { AfterViewInit, Directive, ElementRef, inject, NgZone, OnDestroy } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { take } from 'rxjs';

@Directive({
  selector: '[overflowTooltip]',
  standalone: true,
  hostDirectives: [MatTooltip]
})
export class OverflowTooltipDirective implements AfterViewInit, OnDestroy {
  private elRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private ngZone = inject(NgZone);
  private tooltip = inject(MatTooltip);

  private resizeObserver?: ResizeObserver;
  private mutationObserver?: MutationObserver;

  ngAfterViewInit() {
    this.tooltip.position = 'left';
    this.tooltip.tooltipClass = 'overflow-tooltip';
    this.executeInitialCheck();

    this.ngZone.runOutsideAngular(() => {
      this.checkForElementResizing();
      this.checkForElementMutation();
    });
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
  }

  private executeInitialCheck() {
    this.ngZone.onStable.pipe(take(1)).subscribe(() => {
      this.checkOverflow();
    });
  }

  private checkForElementResizing() {
    this.resizeObserver = new ResizeObserver(() => this.checkOverflow());
    this.resizeObserver.observe(this.elRef.nativeElement);
  }

  private checkForElementMutation() {
    this.mutationObserver = new MutationObserver(() => this.checkOverflow());
    this.mutationObserver.observe(this.elRef.nativeElement, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  private checkOverflow() {
    const host = this.elRef.nativeElement;

    if (host.scrollWidth > host.clientWidth) {
      this.tooltip.message = host.textContent?.trim() ?? '';
      this.tooltip.disabled = false;
    } else {
      this.tooltip.message = '';
      this.tooltip.disabled = true;
    }
  }
}
